import { useState } from "react"
import { Input } from "./Input"
import { PasswordInput } from "./PasswordInput"
import { PrimaryButton } from "../buttons/PrimaryButton"
import { LinkText } from "../buttons/LinkText"
import { useNavigate } from "react-router-dom"
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import { Label } from "./Label"
import { SpinnerContainer } from "../common/SpinnerContainer"
import { createAccount } from "../../api/requests/auth"
import { CreateAccountData } from "../../api/requests/interfaces/Auth"

export const SignupForm: React.FC = () => {
    const [email, setEmail] = useState("");
    const [emailValid, setEmailValid] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordCopy, setPasswordCopy] = useState("");
    const [passwordsMatch, setPasswordsMatch] = useState(false);
    const [passwordValid, setPasswordValid] = useState(false);
    const [name, setName] = useState("");
    const [isSubmitted, setIsSubmitted] = useState(false);

    const [isErrorRequest, setIsErrorRequest] = useState(false);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();

    function isValidEmail(email: string): boolean {
        const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;
        return emailRegex.test(email);
    }

    function isValidPassword(password: string): boolean {
        const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#])[A-Za-z\d@$!%*?&#]{8,}$/;
        return passwordRegex.test(password);
    }

    const handleEmailChange = (val: string) => {
        setEmail(val);
        setEmailValid(isValidEmail(val));
    }

    const handlePassWordChange = (val: string) => {
        setPassword(val);
        setPasswordValid(isValidPassword(val));
    }

    const handlePassWordCopyChange = (val: string) => {
        setPasswordCopy(val);
        if (val != password) {
            setPasswordsMatch(false);
        } else {
            setPasswordsMatch(true)
        }
    }

    const checkFieldValids = (): boolean => {
        return emailValid && passwordValid && passwordsMatch && (name.length > 0)
    }

    const handleAccountCreateClicked = async () => {
        setIsSubmitted(true);
        if (!checkFieldValids()) {
            return;
        }
        setLoading(true);
        try {
            setIsErrorRequest(false);
            const createData: CreateAccountData = {
                email: email,
                password: password,
                password2: passwordCopy,
                name: name
            }
            const res = await createAccount(createData);
            navigate('/email-verify?verificationToken=' + res.emailVerificationToken);
            setLoading(false);
        } catch (e) {
            setIsErrorRequest(true);
            setLoading(false);
        }
    }

    return (
        <div>
                <SpinnerContainer show={loading}>
                    <div className="w-full md:w-[400px] space-y-2 h-fit shadow-main z-10 bg-white px-8 py-7 rounded-xl">
                        <h2>Loo konto</h2>

                        <form onSubmit={(e) => { e.preventDefault() }} className="space-y-2 flex flex-col gap-2">
                            <div>
                                <Label value="Email" />
                                <Input value={email} onChange={(e) => handleEmailChange(e)} placeHolder="Email" name="email" invalid={!emailValid && isSubmitted}
                                    errorText="Email aadress on ebakorrektne"></Input>
                            </div>
                            <div>
                                <Label value="Nimi" />
                                <Input value={name} onChange={(e) => setName(e)} placeHolder="Nimi" name="name" invalid={!(name.length > 0) && isSubmitted} 
                                errorText="Nimi on täitmata"></Input>
                            </div>
                            <div>
                                <div className="flex row align-middle gap-1">
                                    <Label value="Parool" />
                                    <Tooltip title="Parool peab olema pikkusega 8 tähemärki ja sisaldama 1 suurt tähte, 1 numbrit, 1 järgnevatest sümbolitest @$!%*?&#" arrow>
                                        <InfoIcon className="cursor-pointer text-blue-500" style={{ width: '18px', height: '18px' }} />
                                    </Tooltip>
                                </div>
                                <PasswordInput value={password} onChange={(e) => handlePassWordChange(e)} placeHolder="Parool" invalid={!passwordValid && isSubmitted}
                                    errorText="Parool ei vasta nõuetele (nõuded nähtaval info ikoonilt)"></PasswordInput>
                            </div>
                            <div>
                                <div className="flex row align-middle">
                                    <Label value="Parool uuesti" />
                                </div>
                                <PasswordInput value={passwordCopy} onChange={(e) => handlePassWordCopyChange(e)} placeHolder="Parool uuesti"
                                    invalid={!passwordsMatch && password.length > 0 && isSubmitted}
                                    errorText="Parool ei ühti esialgse parooliga"></PasswordInput>
                            </div>
                            {/* <div className="flex">
                            <div className="flex items-center gap-1"><Checkbox checked={true} onChange={(v) => {}}></Checkbox> Jäta mind meelde</div>
                        </div> */}
                            <div className="pt-4">
                                <PrimaryButton title='Loo konto' onClick={handleAccountCreateClicked} />
                                <div className="flex items-start mt-2"><LinkText text="Konto olemas? Logi sisse" onClick={() => navigate('/login')} /></div>
                            </div>
                        </form>
                        {
                            isErrorRequest ?
                            <div className="text-red-500">Konto loomisel esines viga!</div>
                            :
                            <></>
                        }
                    </div>
                </SpinnerContainer>
        </div>
    )
}